import { useSyncExternalStore } from "react";
import { getJiraConnectState, subscribeJiraConnectFlow, type JiraConnectFlowState } from "./flowStore";

export function useJiraConnectFlow(): JiraConnectFlowState {
    return useSyncExternalStore(subscribeJiraConnectFlow, getJiraConnectState);
}
